export const tumbi = {
    tumba__tp_3: {
        name: "Тумба на 3 ящика, мм",
        title: "Тумба на 3 ящика",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__tp_4: {
        name: "Тумба на 4 ящика, мм",
        title: "Тумба на 4 ящика",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__ts_1: {
        name: "Тумба с 2 полками, мм",
        title: "Тумба с 2 полками",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__ts_2: {
        name: "Тумба с 1 ящиком и 1 полкой, мм",
        title: "Тумба с 1 ящиком и 1 полкой",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__ts_3: {
        name: "Тумба с 3 ящиками, мм",
        title: "Тумба с 3 ящиками",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__ts_5: {
        name: "Тумба с 5 ящиками, мм",
        title: "Тумба с 5 ящиками",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__ts_7: {
        name: "Тумба с 7 ящиками, мм",
        title: "Тумба с 7 ящиками",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    tumba__ts_10: {
        name: "Тумба с 10 ящиками, мм",
        title: "Тумба с 10 ящиками",
        price: 0,
        active: false,
        type: "500x590",
        width: 500,
        depth: 590,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
export const krishka_na_tumbu = {
    krishka_na_tumbu__rezina: {
        name: "Крышка на тумбу",
        price: 0,
        active: false,
        type: "Рез. коврик",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    krishka_na_tumbu__fanera: {
        name: "Крышка на тумбу",
        price: 0,
        active: false,
        type: "Фанера",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const podstavka_pmt = {
    podstavka_pmt: {
        name: "Подставка мобильная, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
